var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 5.93815H6.16667C5.69996 5.93815 5.4666 5.93815 5.28834 5.84732C5.13154 5.76743 5.00406 5.63994 4.92416 5.48314C4.83333 5.30488 4.83333 5.07153 4.83333 4.60482V1.77148M13.1667 16.7715V11.4382C13.1667 10.9714 13.1667 10.7381 13.0758 10.5598C12.9959 10.403 12.8685 10.2755 12.7117 10.1956C12.5334 10.1048 12.3 10.1048 11.8333 10.1048H6.16667C5.69996 10.1048 5.4666 10.1048 5.28834 10.1956C5.13154 10.2755 5.00406 10.403 4.92416 10.5598C4.83333 10.7381 4.83333 10.9714 4.83333 11.4382V16.7715M16.5 7.04272V12.7715C16.5 14.1716 16.5 14.8717 16.2275 15.4065C15.9878 15.8769 15.6054 16.2593 15.135 16.499C14.6002 16.7715 13.9001 16.7715 12.5 16.7715H5.5C4.09987 16.7715 3.3998 16.7715 2.86502 16.499C2.39462 16.2593 2.01217 15.8769 1.77248 15.4065C1.5 14.8717 1.5 14.1716 1.5 12.7715V5.77148C1.5 4.37135 1.5 3.67129 1.77248 3.13651C2.01217 2.6661 2.39462 2.28365 2.86502 2.04397C3.3998 1.77148 4.09987 1.77148 5.5 1.77148H11.2288C11.6364 1.77148 11.8402 1.77148 12.0321 1.81753C12.2021 1.85836 12.3647 1.9257 12.5138 2.01708C12.682 2.12015 12.8261 2.26428 13.1144 2.55253L15.719 5.1571C16.0072 5.44536 16.1513 5.58948 16.2544 5.75768C16.3458 5.9068 16.4131 6.06937 16.4539 6.23943C16.5 6.43124 16.5 6.63507 16.5 7.04272Z",
    stroke: "#444CE7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.2409b4c39104da52e2874e753e86a900.svg";
export { ForwardRef as ReactComponent };